import React, { useState } from 'react'
import { Drawer } from 'antd'
import { MenuOutlined } from '@ant-design/icons'
import { HeaderWrapper, HeaderContainer, Logo, MenuWrapper, MenuItem, MobileMenuButton } from './Header.styles'
import { useHistory, useLocation } from 'react-router-dom'
import styled from 'styled-components'

import logo_linhlinh from 'src/assets/images/ic_logo_linhlinh.png'

/* ================= STYLES ================= */

const BrandWrapper = styled.div`
   display: flex;
   align-items: center;
   gap: 10px;
   cursor: pointer;
`

const BrandLogo = styled.img`
   width: 36px;
   height: 36px;
   border-radius: 4px;
   object-fit: contain;
   flex-shrink: 0;

   @media (max-width: 768px) {
      width: 30px;
      height: 30px;
      border-radius: 4px;
   }
`

const BrandText = styled.div`
   display: flex;
   flex-direction: column;
`

const SubTitle = styled.div`
   display: flex;
   align-items: flex-end;
   font-size: 10px;
   font-weight: 400;
   color: #cdcdcd;
   padding-bottom: 2px;
`

const BrandName = styled.span`
   font-size: 11px;
   font-weight: 600;
   color: #edbb1d;
   padding-left: 4px;
`

/* ================= COMPONENT ================= */

const Header: React.FC = () => {
   const [open, setOpen] = useState(false)
   const history = useHistory()
   const location = useLocation()

   const goToSection = (id: string) => {
      if (location.pathname === '/') {
         // Update URL nhưng không reload
         history.replace(`/#${id}`)

         const el = document.getElementById(id)
         el?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      } else {
         // Từ page khác → quay về home + hash
         history.push(`/#${id}`)
      }

      setOpen(false)
   }

   return (
      <>
         <HeaderWrapper>
            <HeaderContainer>
               {/* ===== BRAND ===== */}
               <BrandWrapper onClick={() => history.push('/')}>
                  {/* LOGO TRƯỚC */}
                  <BrandLogo src={logo_linhlinh} alt="LinhLinh36" />

                  {/* TEXT */}
                  <BrandText>
                     <Logo>Xe Ghép Thanh Hóa - Hà Nội</Logo>
                     <SubTitle>
                        Một sản phẩm của
                        <BrandName>LinhLinh36</BrandName>
                     </SubTitle>
                  </BrandText>
               </BrandWrapper>

               {/* ===== MENU DESKTOP ===== */}
               <MenuWrapper>
                  <MenuItem
                     style={{ fontSize: 14, fontWeight: 500 }}
                     onClick={() => (window.location.href = '/about-us')}
                  >
                     Về chúng tôi
                  </MenuItem>

                  <MenuItem style={{ fontSize: 14, fontWeight: 500 }} onClick={() => goToSection('services')}>
                     Dịch vụ
                  </MenuItem>

                  <MenuItem style={{ fontSize: 14, fontWeight: 500 }} onClick={() => goToSection('fleet')}>
                     Đội xe
                  </MenuItem>

                  <MenuItem style={{ fontSize: 14, fontWeight: 500 }} onClick={() => history.push('/news')}>
                     Tin tức
                  </MenuItem>

                  <MenuItem
                     style={{ fontSize: 14, fontWeight: 500 }}
                     onClick={() => (window.location.href = '/contact')}
                  >
                     Liên hệ
                  </MenuItem>
               </MenuWrapper>

               {/* ===== MOBILE MENU ===== */}
               <MobileMenuButton onClick={() => setOpen(true)}>
                  <MenuOutlined />
               </MobileMenuButton>
            </HeaderContainer>
         </HeaderWrapper>

         {/* ===== MOBILE DRAWER ===== */}
         <Drawer placement="right" bodyStyle={{ color: '#000' }} onClose={() => setOpen(false)} visible={open}>
            <p
               onClick={() => {
                  setOpen(false)
                  history.push('/')
               }}
            >
               Trang chủ
            </p>
            <p
               onClick={() => {
                  setOpen(false)
                  window.location.href = '/about-us'
               }}
            >
               Về chúng tôi
            </p>
            <p
               onClick={() => {
                  setOpen(false)
                  goToSection('services')
               }}
            >
               Dịch vụ
            </p>
            <p
               onClick={() => {
                  setOpen(false)
                  goToSection('fleet')
               }}
            >
               Đội xe
            </p>
            <p
               onClick={() => {
                  setOpen(false)
                  history.push('/news')
               }}
            >
               Tin tức
            </p>
            <p
               onClick={() => {
                  setOpen(false)
                  window.location.href = '/contact'
               }}
            >
               Liên hệ
            </p>
         </Drawer>
      </>
   )
}

export default Header
